import SolutionTemplate from '@LandingFunctionalDisplay/SolutionTemplate';
import { retailData } from '@LandingFunctionalDisplay/SolutionTemplate/solutionData';

export default function RetailPage() {
    return <SolutionTemplate {...retailData} />;
}
